module.exports = __webpack_public_path__ + "static/ldf-58675dd0b4e3aa42589e23c1a9aa2886.jpg";